import React, { useCallback } from "react";
import styles from "./index.module.scss";
import { useStore, StoreTypes } from "context";
import DialogModule from "components/Dialogs/";
import { LOGIN_SUCCESS_POPUP } from "constants/loginTypes";

// 南一會員中心登入（NBK-1600）成功視窗，樣式與登出視窗（ConfirmPopup）一致
const LoginSuccessPopup = () => {
	const [{ loginSuccessPopupState }, loginDispatch] = useStore(StoreTypes.login);

	const close = useCallback(() => {
		loginDispatch({ type: LOGIN_SUCCESS_POPUP, loginSuccessPopupState: false });
	}, [loginDispatch]);

	const TextContent = (
		<div className={styles.popUp}>
			<div className={styles.title}>登入成功</div>
		</div>
	);

	const action = (
		<div className={styles.dialogBtn}>
			<div className={styles.ok} onClick={close}>
				確定
			</div>
		</div>
	);

	return (
		<DialogModule
			open={loginSuccessPopupState}
			setOpen={close}
			content={TextContent}
			action={action}
		/>
	);
};

export default LoginSuccessPopup;
